import { useEffect } from 'react';
import {ThunkDispatch} from "@reduxjs/toolkit";
import {useSelector, useDispatch} from 'react-redux'
import LoginGetResetPassEmail from '../components/LoginGetResetPassEmail'
import LoginResetPassEmailSent from '../components/LoginResetPassEmailSent'
import {currentUserActions} from '../reducers/currentUser'

const ResetPassword = ({view} : {view: 'company' | 'talent'}) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const currentUser = useSelector((state: any) => state.currentUser)
  const {isResetPwEmailSent} = currentUser
  useEffect(() => {
    dispatch(currentUserActions.setInitState())
  }, []);

  return (
    <>
      {!isResetPwEmailSent && (
        <LoginGetResetPassEmail view={view} />
      )}
      {isResetPwEmailSent && (
        <LoginResetPassEmailSent view={view} />
      )}
    </>
  );
};

export default ResetPassword;
